import { createAction } from '@reduxjs/toolkit';
// types
import { SOUNDS_CURRENT, SOUNDS_PROGRESS, SOUNDS_READY } from './types';

export const setCurrentSound = createAction<string>(SOUNDS_CURRENT);

export const setProgressSound = createAction<number>(SOUNDS_PROGRESS);

export const setReadySound = createAction<boolean>(SOUNDS_READY);